var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.deleteAccount}},[_vm._v("Close my account and delete my data")])
}
var staticRenderFns = []

export { render, staticRenderFns }